module.exports = __webpack_public_path__ + "media/images/head_bg-6685fe01de43c96848fe4602ba3ea370.gif";